import { css } from '@emotion/css';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { actions } from '../../features/user';
import { throttle } from '../../lib/utils';
import { ConfirmButton } from '../shared/buttons/ConfirmButton';
import { Dialog } from '../shared/dialog/Dialog';

export const ReportedWarningDialog: React.FC = () => {
  const { t } = useTranslation('translation');
  const history = useHistory();
  const dispatch = useDispatch();
  const handleOKClick = useCallback(
    throttle(() => {
      history.goBack();
    }, 1000),
    [dispatch, history]
  );
  useEffect(() => {
    return () => {
      dispatch(actions.reportedWarningFinished());
    };
  }, [dispatch]);

  return (
    <Dialog title={t('dialog_caution')} titleColor="#e60012">
      <>
        <p
          className={css`
            flex: 1 1 auto;
            display: flex;
            color: #e60012;
            padding: 12px 0 32px;
          `}
        >
          {t('error_reported')}
        </p>

        <div
          className={css`
            flex: 0 0 auto;
            padding: 0 0 8px;
          `}
        >
          <ConfirmButton onClick={handleOKClick}>{t('dialog_button_ok')}</ConfirmButton>
        </div>
      </>
    </Dialog>
  );
};
